module.exports = __webpack_public_path__ + "assets/img/shouye_daoyoufuwu.165aea7b.svg";